import { Stack } from '@mantine/core';

import { CollapsableAbstract } from '@/module/AnnualReport/items/collapsable/CollapsableAbstract';
import { CollapsableIsiAbstract } from '@/module/AnnualReport/items/collapsable/CollapsableIsiAbstract';
import { AnnualReportAbstracts } from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualAbstractsOverviewProps {
  abstracts: AnnualReportAbstracts;
}

export function AnnualAbstractsOverview({ abstracts }: AnnualAbstractsOverviewProps) {
  return (
    <Stack gap="xl">
      <CollapsableIsiAbstract
        title="Rezumate publicate în reviste indexate ISI, CU factor de impact"
        abstracts={abstracts.isiWithFiAbstracts}
      />
      <CollapsableIsiAbstract
        title="Rezumate publicate în reviste cotate ISI, FĂRĂ factor de impact"
        abstracts={abstracts.isiWithoutFiAbstracts}
      />
      <CollapsableAbstract
        title="Rezumate publicate în suplimente de reviste indexate BDI"
        abstracts={abstracts.bdiAbstracts}
      />
      <CollapsableAbstract
        title="Rezumate publicate în suplimente de reviste recunoscute de CNCS - categoria B"
        abstracts={abstracts.cncsAbstracts}
      />
      <CollapsableAbstract
        title="Rezumate publicate în volume de rezumate cu ISBN/ISSN, internaționale (altele decât suplimentele de reviste)"
        abstracts={abstracts.internationalVolumeAbstracts}
      />
      <CollapsableAbstract
        title="Rezumate publicate în volume de rezumate cu ISBN/ISSN, naționale (altele decât suplimentele de reviste)"
        abstracts={abstracts.nationalVolumeAbstracts}
      />
    </Stack>
  );
}
